import React from "react";
import Navbar from "../components/common/Navbar";

const ProfilePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-center">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">
              LinkedIn 스타일 프로필 페이지
            </h1>
            <p className="text-gray-600 mb-8">
              이력서, 포트폴리오, 추천서를 관리할 수 있는 프로필 페이지입니다.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div className="p-6 border border-gray-200 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">이력서 관리</h3>
                <p className="text-gray-600 text-sm">PDF 이력서를 업로드하고 관리하세요</p>
              </div>
              <div className="p-6 border border-gray-200 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">포트폴리오</h3>
                <p className="text-gray-600 text-sm">프로젝트와 성과를 시각적으로 보여주세요</p>
              </div>
              <div className="p-6 border border-gray-200 rounded-lg">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">추천서</h3>
                <p className="text-gray-600 text-sm">동료나 상사로부터 추천서를 받으세요</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
